module.exports = __webpack_public_path__ + "static/img/rank_245.449d83f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_245.png
// module id = VbHz
// module chunks = 0